export class Pays {
  id:number;
  libelle:string;
  codeIso:string;
  codeIso2:string;
  codeIso3:string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/pays.model.ts